// extracted by mini-css-extract-plugin
export default {"commonDashboardPage":"style_commonDashboardPage__cgMvx"};